var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7c91d84690c90caa933b7a550958c91.js').default;export default
        Object.assign({}, scope_0 )
    